import React from "react";
import Typography from "@material-ui/core/Typography"
import Button from "@material-ui/core/Button";
import GenericDialog from "../../../../../ui/dialogs/generic-dialog/GenericDialog";

const MessaggioInviatoDialog = (props) => {

    const dialogContent = (
        <React.Fragment>
            <Typography variant={"body2"}>
                Il tuo messaggio è stato inviato correttamente. Verrai contattato dal Servizio Clienti quanto prima.
            </Typography>
        </React.Fragment>
    );

    const dialogActions = (
        <React.Fragment>
            <Button autoFocus
                    onClick={props.handleDialogClose}
                    color="primary"
                    variant="contained"
            >
                Chiudi
            </Button>
        </React.Fragment>
    );

    return (
        <GenericDialog
            dialogWidth="xs"
            open={props.open}
            handleDialogClose={props.handleDialogClose}
            handleDialogCloseButton={props.handleMessaggioInviatoCloseButton}
            dialogActions={dialogActions}
            dialogContent={dialogContent}
        >
            <Typography variant={"h6"}>Messaggio Inviato</Typography>
        </GenericDialog>
    )
}

export default MessaggioInviatoDialog;
